import { Route } from '@angular/router';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { assignableShiftsResolver } from '../../shared/resolvers/assignable-shifts.resolver';

export const vehiclePlanningRoutes: Route[] = [
  {
    path: '',
    title: _('i18n.VehiclePlanning.List.Title'),
    loadComponent: () =>
      import('./vehicle-planning-list/vehicle-planning-list.component').then(
        (m) => m.VehiclePlanningListComponent,
      ),
    resolve: { assignableShifts: assignableShiftsResolver },
  },
];
